import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { adminEnquetesAPI } from '../../utils/adminEnquetesAPI';
import { sucessoComHorario } from '../../utils/toastComHorario';
import ModalRodape from './ModalRodape';

const inputClasses = 'w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-[#40A1E6] focus:ring-2 focus:ring-[#40A1E6]/15 outline-none transition-all';
const labelClasses = 'block text-sm font-medium text-gray-700 mb-1.5';

// Modal de criação — só o essencial: título e descrição, nada mais. Sem
// imagem de capa, sem perguntas, sem configurações aqui dentro — isso tudo
// já tem lugar certo (botões "Configurar"/"Editar Perguntas" na linha da
// lista, disponíveis assim que a enquete existe). Fecha sozinho assim que
// criar; quem chama (GerenciarEnquetes.js) destaca a linha nova na lista
// pra indicar que ela precisa dos próximos passos — não fica encadeando
// modal atrás de modal.
// Visibilidade NUNCA aparece como campo editável aqui — toda enquete nasce
// privada, e só pode virar pública depois de ter pelo menos uma pergunta
// (regra aplicada no backend e no modal "Configurar").
const CriarEnqueteModal = ({ onFechar, onCriada }) => {
  const [enviando, setEnviando] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: { titulo: '', descricao: '' } });

  const onSalvar = async (dados) => {
    setEnviando(true);
    try {
      const criada = await adminEnquetesAPI.criar(dados);
      sucessoComHorario('Enquete criada! Configure imagem e perguntas na lista.');
      onCriada?.(criada);
      onFechar?.();
    } catch (error) {
      toast.error(error.userMessage || 'Erro ao criar enquete');
      setEnviando(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSalvar)} className="space-y-4">
      <div>
        <label htmlFor="criar-enquete-titulo" className={labelClasses}>Título</label>
        <input
          id="criar-enquete-titulo"
          {...register('titulo', { required: 'Título é obrigatório' })}
          className={inputClasses}
          placeholder="Ex: Enquete sobre o novo mercado municipal"
          autoFocus
        />
        {errors.titulo && (
          <p className="text-sm text-red-600 mt-1">{errors.titulo.message}</p>
        )}
      </div>
      <div>
        <label htmlFor="criar-enquete-descricao" className={labelClasses}>Descrição (opcional)</label>
        <textarea id="criar-enquete-descricao" {...register('descricao')} className={inputClasses} rows={3} />
      </div>

      <p className="text-xs text-gray-400 text-center">
        Depois de criada, use "Configurar" e "Editar Perguntas" na lista pra continuar.
      </p>

      <ModalRodape>
        <button type="submit" disabled={enviando} className="btn-primary">
          {enviando ? 'Criando...' : 'Criar enquete e continuar'}
        </button>
      </ModalRodape>
    </form>
  );
};

export default CriarEnqueteModal;
